export interface UpdateCollectionIcTagUidRequest {
  id: number
  icTagUid: string
  revision: number
}

export function UpdateCollectionIcTagUidRequestToJSON(
  value: UpdateCollectionIcTagUidRequest
): any {
  return {
    id: value.id !== 0 ? value.id : undefined,
    ic_tag_uid: value.icTagUid !== '' ? value.icTagUid : undefined,
    revision: value.revision !== 0 ? value.revision : undefined
  }
}
